import BaseActions from '@/store/base/actions'
import Schema from "@/store/modules/projectWeeks/schema"
import MultipleFormActions from '@/store/base/multipleFormData/actions'

const module = 'projectWeeks'

export default BaseActions({module}, {
  //
}, [MultipleFormActions(module), Schema])